import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";

// architecture.md セクション5.1: Web用Firebase設定値は import.meta.env.VITE_FIREBASE_* から受け取る。
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const WORKER_BASE_URL: string = import.meta.env.VITE_WORKER_BASE_URL;

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(firebaseApp);

// 注意: enableIndexedDbPersistence は意図的に使用しない。
// iOS Safariのプライベートブラウズ等でIndexedDBが使えない/不安定なケースを避けるため、
// オンライン専用のシンプルな Firestore クライアントとして初期化する。
export const db: Firestore = getFirestore(firebaseApp);
